<script>import { tooltipAction } from "../../../../actions/tooltip";
import { attrValue } from "../../../../utils/html";
import Input from "../Input.svelte";
import DynamicComponent from "../../../components/DynamicComponent.svelte";
export let props;
$: columnClass = attrValue([
  props?.column ? " flex flex-col space-y-3 items-start text-start" : "flex justify-center items-start"
]);
props.classNames = props?.column ? `${props?.classNames}` : `${columnClass}`;
const handleChange = (e) => {
  if (!props.touched) {
    props.touched = true;
  }
  if (!props.dirty) {
    props.dirty = true;
  }
  if (props.handleChangeCallbackFunction) {
    props.handleChangeCallbackFunction(e);
  }
};
</script>

<Input bind:props isErrorDisplayed={false}>
	<div
		class=" {columnClass} {props.isBoxLayout
			? 'flex gap-3 snap-mandatory snap-x w-auto lg:grid lg:grid-cols-4 lg:gap-2'
			: ''}"
	>
		{#if props?.options}
			{#each props.options as { id, value, label, disabled, tooltip, classNames = { } }}
				<!-- svelte-ignore a11y-no-noninteractive-element-to-interactive-role -->
				<label
					use:tooltipAction={tooltip}
					class:component={typeof label != 'string'}
					class:selected={props?.value?.includes(value) && !disabled}
					id={props.id}
					data-id={id}
					role="button"
					class="{props.isBoxLayout
						? 'w-2/3 md:w-1/3 lg:w-auto flex-shrink-0 lg:flex-shrink snap-center'
						: ''} {classNames ? classNames : ''}"
				>
					<input
						type="checkbox"
						data-id={id}
						{value}
						bind:group={props.value}
						on:change={handleChange}
						class:selected={props?.value?.includes(value) && !disabled}
						class:hidden={true}
						disabled={disabled || props.disabled}
					/>
					{#if label}
						{#if typeof label == 'string'}
							{label}
						{:else}
							<div
								class="wrapper p-3 border border-grey-light rounded h-full"
								class:selected={props?.value?.includes(value) && !disabled}
							>
								<DynamicComponent component={label} />
							</div>
						{/if}
					{/if}
				</label>
			{/each}
		{/if}
	</div>
</Input>

<style>.wrapper.selected{border-color:var(--color-secondary)}label:not(.component){--radio-size:1em;padding-left:calc(1em + .25rem);padding-left:calc(var(--radio-size) + .25rem);position:relative}label:not(.component):after,label:not(.component):before{background-color:#fff;content:"";left:0;pointer-events:none;position:absolute;top:50%;transform-origin:center center;z-index:1}label:not(.component):before{border:1px solid #e6e6e6;display:block;height:var(--radio-size);transform:translateY(-50%);transition:borderColor .1s ease-out;width:var(--radio-size)}label:not(.component):hover:before{transition-timing-function:ease-in}label:not(.component):hover:not(.disabled):before{border-color:var(--color-primary)}label:not(.component):after{background-color:var(--color-primary);display:block;height:var(--radio-size);transform:scale(0);transition:transform .1s ease-out .05s;width:var(--radio-size);z-index:2}.selected:not(.component):after{transform:scale(.6) translateY(-80%);transition-delay:0s;transition-timing-function:ease-in}.selected:not(.component):before{border-color:var(--color-primary)}.disabled.selected:not(.component):before,label:not(.component):not(.disabled):hover:before{border-color:var(--color-primary-light)}.disabled.selected:not(.component):after{background-color:var(--color-primary-light)}</style>
